import { GoogleAnalyticsDataLayerParameters, GoogleAnalyticsQuoteBase, GoogleAnalyticsStudentDetails } from '@lx/shared/google-analytics';

export interface GoogleAnalyticsQuoteToolLiteQuote extends GoogleAnalyticsQuoteBase {
  /**
   * The number of quotes requested.
   * Every time users click on the "Start again" button, this number increases by 1
   */
  quote?: number;
  quote_time_zone?: string;
  quote_class_time?: string;
  quote_transfer_type?: string;
  quote_premium_activities?: string;
  quote_junior_unaccompanied_service?: string;
}

export interface GoogleAnalyticsParametersType extends GoogleAnalyticsDataLayerParameters, GoogleAnalyticsStudentDetails {
  quotes?: GoogleAnalyticsQuoteToolLiteQuote[];
  step?: string;
  deeplink_type?: string;
}
